import { createContext } from 'react'
import { PurchaseOrder } from '../type/purchase-order'
import { MessageInstance } from 'antd/es/message/interface'

export type PurchaseOrderListItemContextValue = {
  entity: PurchaseOrder
  message: MessageInstance
  onAfterDelete?: () => void
}

export const PurchaseOrderListItemContext = createContext<PurchaseOrderListItemContextValue>({} as PurchaseOrderListItemContextValue)